import React from 'react';

const ErrorIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="8" cy="8" r="8" fill="white" />
      <mask id="path-2-inside-1_874:7554" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM8 13C7.44771 13 7 12.5523 7 12V8C7 7.44772 7.44771 7 8 7C8.55228 7 9 7.44771 9 8V12C9 12.5523 8.55228 13 8 13ZM8 3.41443C7.44771 3.41443 7 3.86214 7 4.41443C7 4.96671 7.44771 5.41443 8 5.41443C8.55228 5.41443 9 4.96671 9 4.41443C9 3.86214 8.55228 3.41443 8 3.41443Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM8 13C7.44771 13 7 12.5523 7 12V8C7 7.44772 7.44771 7 8 7C8.55228 7 9 7.44771 9 8V12C9 12.5523 8.55228 13 8 13ZM8 3.41443C7.44771 3.41443 7 3.86214 7 4.41443C7 4.96671 7.44771 5.41443 8 5.41443C8.55228 5.41443 9 4.96671 9 4.41443C9 3.86214 8.55228 3.41443 8 3.41443Z"
        fill="#FB534A"
      />
      <path
        d="M8 15C4.13401 15 1 11.866 1 8H-1C-1 12.9706 3.02944 17 8 17V15ZM15 8C15 11.866 11.866 15 8 15V17C12.9706 17 17 12.9706 17 8H15ZM8 1C11.866 1 15 4.13401 15 8H17C17 3.02944 12.9706 -1 8 -1V1ZM1 8C1 4.13401 4.13401 1 8 1V-1C3.02944 -1 -1 3.02944 -1 8H1ZM6 12C6 13.1046 6.89543 14 8 14V12H6ZM6 8V12H8V8H6ZM8 6C6.89543 6 6 6.89543 6 8H8V6ZM10 8C10 6.89543 9.10457 6 8 6V8H10ZM10 12V8H8V12H10ZM8 14C9.10457 14 10 13.1046 10 12H8V14ZM8 4.41443V2.41443C6.89543 2.41443 6 3.30986 6 4.41443H8ZM8 4.41443H6C6 5.519 6.89543 6.41443 8 6.41443V4.41443ZM8 4.41443V6.41443C9.10457 6.41443 10 5.519 10 4.41443H8ZM8 4.41443H10C10 3.30986 9.10457 2.41443 8 2.41443V4.41443Z"
        fill="#FB534A"
        mask="url(#path-2-inside-1_874:7554)"
      />
    </svg>
  );
};

export default ErrorIcon;
